export default function({ state, commit, dispatch, rootState }, query) {
    return dispatch('get', {
        url: '/provider/' + query.provider + '/patient/' + query.patient + '/revision',
        query: {
            type: query.type,
            id: query.id,
            ...(query.event ? {event: query.event} : {})
        }
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => console.error('Error loading history ', error))
}